import wixLocation from 'wix-location';
import { biLoggerFactory } from 'wix-private';
const biLogger = biLoggerFactory('lp', 19, { msid: 'cea1e625-ef4a-40d7-bef8-2d50ce63a50e' });

$w.onReady(function () {

});
async function fireEvent(button) {
	const biEventObject = {
		evid: 703,
		button_name: button,
		is_valid: true,
		topic: 'wix partners site',
		url: wixLocation.url
	};
	await biLogger.log(biEventObject);
}

export async function joinNow_click(event) {
	await fireEvent('joinnow')
}

export async function resources_click(event) {
	await fireEvent('resources')
}

export async function forum_click(event) {
	await fireEvent('forum')
}

export async function blog_click(event) {
	await fireEvent('blog')
}

export async function schedule_click(event) {
	await fireEvent('schedule a call')
}



export async function bookAdemoHeader_click(event) {
	await fireEvent('book a demo') 
}

export async function bookAdemoExperience_click(event) {
	await fireEvent('book a demo')
}

export async function learnMoreLeads_click(event) {
	await fireEvent('join marketplace')
}

export async function joinNowRevenue_click(event) {
	await fireEvent('join now') 
}

export async function bookAdemoPartner_click(event) {
	await fireEvent('book a demo') 
}


export async function joinNowExperience_click(event) {
	await fireEvent('join now') 
}

export async function joinNowAgency_click(event) {
	await fireEvent('join now') 
}

export async function joinNowPartner_click(event) {
	await fireEvent('join now') 
}

export function button234_click(event) {
wixLocation.to('https://www.wix.com/partners/benefits')
}